import { getUserInfo, refreshToken, loginOut } from '@/api/index.js';
import { getToken, setToken, removeToken } from '@/utils/cookie';
import { getStore, setStore, removeStore } from '@/utils/storage';
const state = {
    loginName: getStore('loginName'),
    rememberMe: false,
    menuList: [],
    redirectUri: '',
    token: getToken(),
    cartList: getStore('buyCart'),
    orderList: getStore('orderList'),
    stratetyList: getStore('stratetyList'),
    spellList: getStore('spellList'),
    isLogin: false,
    isStatement: false,
    sheetList: [],
    authToken: {
        access_token: '',
        expires_in: '',
        timestamp: ''
    },
    refreshToken: {
        refresh_token: ''
    },
};

const mutations = {
    SET_SHEETLIST: (state, sheetList) => {
        state.sheetList = sheetList
    },
    SET_ISLOGIN: (state, isLogin) => {
        state.isLogin = isLogin
    },
    SET_ISSTATEMENT: (state, isStatement) => {
        state.isStatement = isStatement
    },
    SET_CODE: (state, code) => {
        state.code = code
    },
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_STRATETYLIST: (state, stratetyList) => {
        state.stratetyList = stratetyList
    },
    SET_SPELLLIST: (state, spellList) => {
        state.spellList = spellList
    },
    SET_CARLIST: (state, cartList) => {
        state.cartList = cartList
    },
    SET_ORDERLIST: (state, orderList) => {
        state.orderList = orderList
    },
    SET_INTRODUCTION: (state, introduction) => {
        state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
        state.setting = setting
    },
    SET_STATUS: (state, status) => {
        state.status = status
    },
    SET_LOGINNAME: (state, loginName) => {
        state.loginName = loginName
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
};

const actions = {
    get_access_token({ commit }, cb) {
        // if (!state.authToken || state.authToken.access_token === '') {
        //     state.authToken = PcCookie.get(enums.USER.AUTH_TOKEN) ? JSON.parse(PcCookie.get(enums.USER.AUTH_TOKEN)) : {};
        // }
        //console.info('refresh_token:', state.token);
        cb && cb(state.token);
    },
    set_sheet_list({ commit }, sheetList) {
        commit('SET_SHEETLIST', sheetList);
        setStore('sheetList', sheetList)
    },
    update_auth_token({ commit }, authToken) {
        state.authToken = authToken;
        commit('SET_TOKEN', authToken.access_token);
        console.log(11111111, authToken.access_token)
        commit('SET_LOGINNAME', authToken.loginName);
        setStore('loginName', authToken.loginName)
        // setStore('loginName', authToken.loginName)
        setToken(authToken.access_token);
    },
    delete_user_info({ commit }, loginName) {
        removeToken();
        commit('SET_TOKEN', '')
        removeStore('buyCart')
        commit('SET_CARLIST', '')
        commit('SET_LOGINNAME', '');
        removeStore('loginName')
        // removeStore("loginName")
    },
    // 获取用户信息
    GetUserInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
            getUserInfo(state.token).then(response => {
                if (!response.data) { // 由于mockjs 不支持自定义状态码只能这样hack
                    reject('error')
                }
                const data = response.result;
                //改过的
                commit('SET_LOGINNAME', data.loginName)
                setStore('loginName', data.loginName)
                // setStore('loginName', data.loginName)
                // commit('SET_AVATAR', data.avatar)
                // commit('SET_INTRODUCTION', data.introduction)
                resolve(response)
            }).catch(error => {

                console.log(error)
                reject(error)
            })
        })
    },
    // 退出登录
    LoginOut({ commit, state }) {
        return new Promise((resolve, reject) => {
            loginOut(state.token).then(response => {
                // if (!response.data) { // 由于mockjs 不支持自定义状态码只能这样hack
                //     reject('error')
                // }
                removeToken();
                commit('SET_TOKEN', '')
                removeStore('buyCart')
                commit('SET_CARLIST', '')
                commit('SET_LOGINNAME', '')
                removeStore('loginName')
                // removeStore('loginName')
                // const data = response.result;
                // //改过的
                // commit('SET_LOGINNAME', data.loginName)
                //     // commit('SET_AVATAR', data.avatar)
                //     // commit('SET_INTRODUCTION', data.introduction)
                // resolve(response)
            }).catch(error => {

                console.log(error)
                reject(error)
            })
        })
    },
    add_strategy_list({ commit }, strategyForm) {
        commit('SET_STRATETYLIST', JSON.stringify(strategyForm))
        setStore('stratetyList', strategyForm)
    },
    remove_strategy_List({ commit }) {
        commit('SET_STRATETYLIST', '')
        setStore('stratetyList', '')
        removeStore('stratetyList')
    },
    add_spell_list({ commit }, spellForm) {
        commit('SET_SPELLLIST', JSON.stringify(spellForm))
        setStore('spellList', spellForm)
    },
    remove_spell_List({ commit }) {
        commit('SET_SPELLLIST', '')
        setStore('spellList', '')
        removeStore('spellList')
    },
    add_cart_list({ commit }, localData) {
        //{ productId, productPrice, productName, productMainImage, productSubtitle, quantity = 1 }
        let cart = []
        if (state.cartList) {
            cart = JSON.parse(state.cartList) || [] // 购物车
        }
        let falg = true
        let goods = localData
        console.log(34343, goods)
        if (cart.length != 0) { // 有内容
            cart.forEach(item => {
                if (item.productId === goods.productId && item.skuId == goods.skuId && item.made == goods.made) {
                    if (item.quantity >= 0) {
                        falg = false;
                        item.quantity = parseInt(item.quantity)
                        item.quantity += parseInt(goods.quantity)
                    }
                }
            })
        }
        if (!cart.length || falg) {
            goods.checked = '1'
            cart.push(goods)
        }
        console.log(3435453, cart)
        commit('SET_CARLIST', JSON.stringify(cart))
        setStore('buyCart', cart)
    },
    update_cart_list({ commit }, list) {
        let localData = JSON.parse(list)
        localData.forEach((item, index) => {
            if (item.checked || item.checked == 1) {
                item.checked = 1
            } else {
                item.checked = 0
            }
        })
        if (localData.length == 0) {
            setStore('buyCart', '')
            removeStore('buyCart');
            return;
        }
        setStore('buyCart', localData)
        setStore('buyCart', localData)
    },
    remove_car_List({ commit }, list) {
        setStore('buyCart', '')
        removeStore('buyCart')
    },
    set_order_list({ commit }, orderList) {
        commit('SET_ORDERLIST', JSON.stringify(orderList))
        setStore('orderList', orderList)
    },
    remove_order_list({ commit }, list) {
        setStore('orderList', '')
        removeStore('orderList')
    },
};


function jumpLoginPage() {
    if (process.env.NODE_ENV === 'production') {
        window.location.href = 'http://login.paascloud.net/login';
    } else {
        window.location.href = 'http://dev-login.paascloud.net/login';
    }
}

export default {
    state,
    actions,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/user/index.js